import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  TopToolbar,
  CreateButton,
  ExportButton,
  SearchInput,
  SelectInput,
  DateInput,
  EditButton,
  ShowButton,
  DeleteButton,
  ReferenceField,
  FunctionField,
  useRedirect,
} from 'react-admin';
import { Chip } from '@mui/material';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const BillFilters = [
  <SearchInput key="search" source="q" placeholder="Search bills..." alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    label="Status"
    choices={[
      { id: 'draft', name: 'Draft' },
      { id: 'sent', name: 'Sent' },
      { id: 'approved', name: 'Approved' },
      { id: 'rejected', name: 'Rejected' },
      { id: 'expired', name: 'Expired' },
    ]}
    alwaysOn
  />,
  <DateInput key="dateFrom" source="dateFrom" label="From Date" />,
  <DateInput key="dateTo" source="dateTo" label="To Date" />,
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const StatusChip = ({ record }: { record: any }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'draft':
        return 'default';
      case 'sent':
        return 'info';
      case 'approved':
        return 'success';
      case 'rejected':
        return 'error';
      case 'expired':
        return 'warning';
      default:
        return 'default';
    }
  };

  return (
    <Chip
      label={record.status?.toUpperCase() || 'UNKNOWN'}
      color={getStatusColor(record.status) as any}
      size="small"
    />
  );
};

export const BillList = () => {
  const redirect = useRedirect();

  const handleCreateBill = () => {
    redirect('/bills/create');
  };

  return (
    <List
      filters={BillFilters}
      actions={<ListActions />}
      perPage={25}
      sort={{ field: 'createdAt', order: 'DESC' }}
      empty={<CustomEmptyState resource="bills" onAction={handleCreateBill} />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="billNumber" label="Number" />
        <ReferenceField source="customerId" reference="customers" link="show">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="title" />
        <NumberField source="totalAmount" options={{ style: 'currency', currency: 'USD' }} />
        <FunctionField
          source="status"
          label="Status"
          render={(record: any) => <StatusChip record={record} />}
        />
        <DateField source="validUntil" label="Valid Until" />
        <DateField source="createdAt" label="Created" showTime />
        <EditButton />
        <ShowButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
